import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const PlentyLogo: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG viewBox="0 0 20 20" {...props}>
            <IconPath
                d="M12.6082 5.83769C12.6435 5.78261 12.7233 5.78301 12.7581 5.83844L18.2783 14.645C18.3159 14.7049 18.2733 14.7832 18.2031 14.7832H10.3915C10.3615 14.7832 10.3336 14.7679 10.3171 14.7426L9.02379 12.7557L8.3091 13.8711L9.44967 15.6234C9.60271 15.8585 9.86242 16 10.1408 16H19.322C19.8556 16 20.1794 15.4048 19.8937 14.9491L13.2133 4.29154C12.971 3.9051 12.4144 3.90232 12.1684 4.28627L5.46868 14.7421C5.45227 14.7677 5.42415 14.7832 5.39398 14.7832H1.79096C1.72098 14.7832 1.67838 14.7053 1.71558 14.6453L5.10621 9.18226C5.14066 9.12677 5.22033 9.1259 5.25595 9.18062L6.73139 11.4473L7.44608 10.3319L5.68648 7.6287C5.43812 7.24715 4.88266 7.25324 4.64254 7.64013L0.10464 14.9517C-0.178276 15.4075 0.145773 16 0.678024 16H5.64682C5.9273 16 6.18868 15.8563 6.34119 15.6183L7.88157 13.2143L12.6082 5.83769Z"
                fill="currentColor"
                stroke="none"
                {...pathProps}
            />
        </IconSVG>
    );
};
